export enum LoginErrors {
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  TEMPORARY_BAN = 'TEMPORARY_BAN',
  PERMANENT_BAN = 'PERMANENT_BAN',
}
